import app from './index';
import bugsnagClient from '../global/bugsnag';
import { mountHeaderAds } from './header-ads/entry-client';

mountHeaderAds();

const headerId = "websiteHeaderVue";
const header = document.getElementById(headerId);

if (header) {
	app.$mount(header);
} else {
	/* This is creating too much noise in BugSnag from blocked clients. Needs discussing before we re-enable it
	const pagesWithoutHeader = ['/checkout', '/automotive-scheduler', '/sales-flyer-mobile', '/account/certificate-mobile'];
	if (!pagesWithoutHeader.find(p => window.location.pathname.startsWith(p))) {
		const message = `Attempted to mount header at "${window.location.pathname}", but root element #${headerId} not found.`;
		// eslint-disable-next-line no-console
		console.warn(message);
		bugsnagClient.notify(new Error(message));
	}
	*/
}